import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as StepIcon } from '../../images/finish-step-icon.svg';

export const FinishStepIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} component={StepIcon} />
);

export default FinishStepIcon;
